// Messages for operator/Notifications (auto-merged by lib/i18n.ts).
export const en = {
  'operator.notifications.head': 'Notifications — Operator',
}

export const zhTW = {
  'operator.notifications.head': '通知 — 操作端',
}
